// extracted by mini-css-extract-plugin
export default {"container":"TodoList_container__Jmh-0","title":"TodoList_title__lvdXX","items":"TodoList_items__R9G3u","add":"TodoList_add__XYRAa","input":"TodoList_input__nt+y3"};